export default "__VITE_ASSET__kGons2kQ__"